import React from 'react'
import './App.css';
import Login from './pages/auth/Login';
import Dashboard from './pages/Dashboard';
import Billing from './pages/Billing';
import User from './pages/User';
import ApiDocumention from './pages/Api-Documention';
import WebHook from './pages/Web-Hook-Document';
import WebHookLogs from './pages/WebHook-Logs';
import SendMessage from './pages/SendMessage';
import DomainError from './pages/DomainError';
import NotFound from './pages/NotFound';
import { PrivateRoute, PermissionRoute } from './components';
import { CsvExportProvider } from './context/CsvExportContext';
import { Routes, Route, useNavigate, useParams, useLocation, Navigate } from "react-router-dom";
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import MessageLogs from './pages/MessageLogs';
import ReminderLogs from './pages/ReminderLogs';
import RoutingMethods from './pages/RoutingMethods';
import ConfigurePushNotification from './pages/configurePushNotification/ConfigurePushNotification';
import Configuresdk from './pages/ConfigureSDK/Configuresdk';
import ConfiguresdkLegacy from './pages/ConfigureSDK/ConfiguresdkLegacy';
import MessageLogReport from './pages/MessageLogs/Report';
import ParserList from './pages/Parser/Parser';
import MessageAPIDoc from './pages/MessageAPI/MessageApi';
import ConfigureAPN from './pages/ConfigureApn/APN';
import Campaign from './pages/Campaign/Campaign.jsx';
import AddCampaign from './pages/Campaign/AddCampaign/AddCampaign.jsx';
import ContactsManagement from './pages/Contact/index.jsx';
import EditCampaign from './pages/Campaign/AddCampaign/EditCampaign.jsx';
import CampaignReport from './pages/Campaign/CampaignReport/Index.jsx';
import WebhookDocumentation from './pages/WebHookDocs/WebhookDocumentation.jsx';
import Cohort from './pages/Cohorts/Cohort.jsx';
import Boards from './pages/Boards/Boards.jsx';
import AddCohorts from './pages/Cohorts/AddCohorts.jsx';
import EditCohorts from './pages/Cohorts/EditCohort.jsx';
import CohortsDetails from './pages/Cohorts/CohortsDetails.jsx';
import Events from './pages/Events/Events.jsx';
import ExecutionReprt from './pages/Cohorts/CohortExecutionReport/ExecutionReprt.jsx';
import IncommingSMS from './pages/IncommingSMS/IncommingSMS.jsx';
import TemplateManager from './pages/TemplateManager/index.jsx';
import EventDocumentation from './pages/EventDocumentation/EventDocumentation.jsx';
import ContactApiDoc from './pages/ContactApiDoc/ContactApiDoc.jsx';
import SMSGrouping from './pages/Tools/SMSGrouping/SMSGroup.jsx';
import SafeMessageFilter from './pages/Tools/SafeMessage/SafeMessageFilter.jsx';
import Roles from './pages/RolesPermission.jsx/Roles.jsx';
import ContactReport from './pages/Contact/ContactReport.jsx';
import CampaignFlowBuilder from './pages/FlowBuilder/index.jsx';
import EditFlow from './pages/FlowBuilder/EditFlow.jsx';
import FlowList from './pages/FlowBuilder/FlowList.jsx';
import TemplateManagerNew from './pages/TemplateManager/CreateTemplate/TemplateManagerNew.jsx';
import SmartLinks from './pages/SmartLinks/SmartLinks.jsx';
import TemplateManagerNewCreate from './pages/TemplateManager/CreateTemplate/TemplateManagerNew.jsx';
import ChannelOptDoc from './pages/ChannelOptDocument/ChannelOptDoc.jsx';
import FlowExecution from './pages/FlowBuilder/FlowExecution/Flowexecution.jsx';
import ExecutionDetail from './pages/FlowBuilder/FlowExecutionDetails/ExecutionDetails.jsx';
import FunnelList from './pages/Funnels/FunnelsList.jsx';
import FunnelBuilder from './pages/Funnels/Builder/FunnelBuilder.jsx';
import EditFunnel from './pages/Funnels/Builder/EditFunnel.jsx';
import SessionJourneyExplorer from './pages/SessionJourney/SessionJourney.jsx';
import SessionAnalyzer from './pages/SessionAnalyzer/SessionAnalyzer.jsx';
import DeepLinkLibrary from './pages/DeepLinkLibrary/DeepLinkLibrary.jsx';
import ReminderList from './pages/Reminders/ReminderList.jsx';
import ReminderEditor from './pages/Reminders/ReminderEditor.jsx';
import { Asklytics } from './pages/Asklytics/Asklytics.jsx';
import CSVMessageSender from './pages/Tools/CSVMessageSender/index.jsx';
import ConversionEvents from './pages/Tools/ConversionEvents/index.jsx';
import EmailDesignerTool from './pages/Tools/EmailDesigner/index.jsx';
import InAppDesigner from './pages/Tools/InAppDesigner/InAppDesigner.tsx';
import InAppMessageList from './pages/Tools/InAppDesigner/InAppMessageList.jsx';
import InAppAnalytics from './pages/Tools/InAppDesigner/InAppAnalytics.jsx';
import EmailTemplateList from './pages/Tools/EmailDesigner/EmailTemplateList.jsx';
import CSVCampaignReport from './pages/Tools/CSVMessageSender/Components/CSVReports.jsx';
import EditorPage from './pages/EditorPage';
import StoryPlayer from './pages/StoryPlayer';
import StoryViewPage from './pages/StoryViewPage';
import StoryDashboard from './pages/StoryDashboard';
import MyTickets from './pages/tickets/tickets/MyTickets.jsx';
import TicketDetail from './pages/tickets/tickets/TicketDetail.jsx';
import CreateTicket from './pages/tickets/tickets/CreateTicket.jsx';
import RFMModels from './pages/RFMModels/RFMModels.jsx';
import RFMConfiguration from './pages/RFMModels/RFMConfiguration.jsx';
import RFMDashboard from './pages/RFMModels/RFMDashboard.jsx';
import UsageReport from './pages/Reports/UsageReport.jsx';
import MetricTreeList from './pages/MetricTree/MetricTreeList.jsx';
import Analytics from './pages/Analytics/Analytics'; // FEAT-ANALYTICS-001 — GA-style reporting
import MetricTreeCanvas from './pages/MetricTree/MetricTreeCanvas.jsx';
import { PRIMARY_SCALE } from './theme/brand';

/*
 * NOTE: brand values are deliberately NOT re-exported from here.
 *
 * App.js imports every page, so anything importing back from App.js creates an
 * import cycle — webpack then resolves the named export to undefined ("possible
 * exports: default"). Import from 'src/theme/brand' directly instead. In JSX and
 * CSS prefer `var(--brand-primary)`; reach for the JS values only where CSS
 * variables cannot reach (Highcharts, react-pdf, exported email HTML).
 */


/**
 * Temporary redirect for routes moved under /analytics — the top nav's links
 * come from the backend's permission/nav data (Header.js renders `to={'/'+page.slug}`
 * straight from that), not from this route list. Until the backend's nav slug for
 * each moved page is updated to the new path, the old URL needs to keep working.
 * Safe to delete each line here once the matching backend slug is updated.
 */
function LegacyRedirect({ toTemplate }) {
  const params = useParams();
  const location = useLocation();
  let to = toTemplate;
  Object.keys(params).forEach((key) => {
    to = to.replace(`:${key}`, params[key]);
  });
  return <Navigate to={`${to}${location.search}`} replace />;
}

function App() {
  const navigate = useNavigate();
  const Button = {

    variants: {
      ghost: {
        bg: "transparent",
        color: "gray.700",
        _hover: {
          bg: "#e2e8f0 !important",
          color: "black !important"
        },
        _active: {
          bg: "gray.200",
        },
        _focus: {
          boxShadow: "none",
        },
      },
    },
  };

  const theme = extendTheme({
    colors: {
      // Both names resolve to the env-driven brand ramp from src/theme/brand.js,
      // so `colorScheme="brand"` / `bg="primary.500"` follow REACT_APP_PRIMARY_COLOR.
      // (This replaced a stale hardcoded green palette that nothing consumed.)
      brand: PRIMARY_SCALE,
      primary: PRIMARY_SCALE,
      // Chakra's built-in `blue` is remapped onto the brand ramp on purpose.
      // ~129 call sites use colorScheme="blue" for primary Buttons, Tabs, Tags and
      // Badges, and Chakra also defaults every Input/Select/Textarea focus ring to
      // blue.500. Without this they would all stay blue under a non-blue brand.
      // Semantic colours (green/red/orange, and the per-channel colours such as
      // SMS #155dfc) are deliberately left alone.
      blue: PRIMARY_SCALE,
    },
    components: {
      Button,
    },
    // fontWeights: {
    //   normal: 300,
    //   medium: 400,
    //   semibold: 500,
    //   bold: 600,
    //   extrabold: 700,
    // },
    // // styles: {
    // //   global: {
    // //     '.chakra-text': {
    // //       fontWeight: '500', // semi-bold by default
    // //     },
    // //   },
    // // },

  });



  return (

    <ChakraProvider theme={theme}>
      <CsvExportProvider>

      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/incomming-sms" element={
          <PrivateRoute>
            <IncommingSMS header={"Incoming SMS Messages"} />

          </PrivateRoute>
        } />

        <Route path="/dashboard" element={
          <PrivateRoute>
            <Dashboard header={"Dashboard"} />
          </PrivateRoute>
        } />

        {/* Legacy, unguarded page — superseded by /message-logs. Kept as a
            redirect (not deleted) since old links/bookmarks may still point here. */}
        <Route path="/delivery-report" element={<LegacyRedirect toTemplate="/message-logs" />} />

        <Route path="/billing" element={
          <PrivateRoute>
            <Billing />
          </PrivateRoute>
        } />

        {/* Legacy, unguarded, no longer in use (confirmed by user 2026-10-07) and
            has no modern replacement to redirect to — route removed, falls
            through to the catch-all 404 below. */}

        <Route path="/user-management/user" element={
          <PrivateRoute>
            <User header={"Manage Users"} />
          </PrivateRoute>
        } />
        <Route path="/user-management/roles-permission" element={
          <PrivateRoute>
            <Roles header={"Manage Users"} />
          </PrivateRoute>
        } />
        <Route path="/webhook" element={
          <PrivateRoute>
            <WebHookLogs header={"WebHook Logs"} />
          </PrivateRoute>
        } />
        <Route path="/parser" element={
          <PrivateRoute>
            <ParserList header={"Message Parser"} />
          </PrivateRoute>
        } />

        <Route path="/documentation/api-doc" element={
          <PrivateRoute>
            <ApiDocumention header={"Variable API Documentation"} />
          </PrivateRoute>
        } />
        <Route path="/documentation/evt-docs" element={
          <PrivateRoute>
            <EventDocumentation header={"Variable API Documentation"} />
          </PrivateRoute>
        } />
        <Route path="/documentation/contact-api" element={
          <PrivateRoute>
            <ContactApiDoc header={"Contact API Documentation"} />
          </PrivateRoute>
        } />

        <Route path="/web-hook" element={
          <PrivateRoute>
            <WebHook />
          </PrivateRoute>
        } />

        <Route path="/send-message" element={
          <PrivateRoute>
            <SendMessage header={"Send Test Message"} />

          </PrivateRoute>
        } />
        <Route path="/report" element={
          <PrivateRoute>
            <MessageLogReport />

          </PrivateRoute>
        } />
        <Route path="/analytics/usage-report" element={
          <PrivateRoute>
            <UsageReport header="Usage Report" />
          </PrivateRoute>
        } />
        <Route path="/marketing/campaign" element={
          <PrivateRoute>
            <Campaign header={"Campaign Manager"} />

          </PrivateRoute>
        } />
        <Route path="/campaign/add" element={
          <PermissionRoute group="marketing/campaign" slug={["campaign-list", "campaign-create"]} requireAll>
            <AddCampaign header={"Campaign Manager"} />

          </PermissionRoute>
        } />
        <Route path="/marketing/cohorts" element={
          <PrivateRoute>
            <Cohort header={"Cohort Analysis"} />

          </PrivateRoute>
        } />
        {/* FEAT-BOARDS-0001 — Mixpanel-style narrative dashboards */}
        <Route path="/analytics/insights" element={<PrivateRoute><Boards /></PrivateRoute>} />
        <Route path="/analytics/insights/:id" element={<PermissionRoute group="analytics/insights" slug="board-view"><Boards /></PermissionRoute>} />
        <Route path="/cohort-report/:id" element={
          <PermissionRoute group="marketing/cohorts" slug="cohort-report">
            <ExecutionReprt header={"Execution Report"} />

          </PermissionRoute>
        } />
        <Route path="/marketing/event" element={
          <PrivateRoute>
            <Events header={"Event Management"} />

          </PrivateRoute>
        } />
        <Route path="/tools/sms-group" element={
          <PrivateRoute>
            <SMSGrouping header={"Event Management"} />

          </PrivateRoute>
        } />
        <Route path="/tools/safe-message-filter" element={
          <PrivateRoute>
            <SafeMessageFilter header={"Event Management"} />

          </PrivateRoute>
        } />
        <Route path="/tools/csv-message-sender" element={
          <PrivateRoute>
            <CSVMessageSender header={"Event Management"} />

          </PrivateRoute>
        } />
        <Route path="/tools/conversion-events" element={
          <PrivateRoute>
            <ConversionEvents />
          </PrivateRoute>
        } />
        <Route path="/tools/csv-message-sender-report/:id" element={
          <PrivateRoute>
            <CSVCampaignReport header={"Event Management"} />

          </PrivateRoute>
        } />
        <Route path="/tools/email-templates" element={
          <PrivateRoute>
            <EmailTemplateList />
          </PrivateRoute>
        } />
        <Route path="/tools/email-designer" element={
          <PermissionRoute group="tools/email-templates" slug="email-template-create">
            <EmailDesignerTool />
          </PermissionRoute>
        } />
        <Route path="/tools/email-designer/:id" element={
          <PermissionRoute group="tools/email-templates" slug={["email-template-view", "email-template-edit"]}>
            <EmailDesignerTool />
          </PermissionRoute>
        } />
        <Route path="/tools/in-app-messages" element={
          <PrivateRoute>
            <InAppMessageList />
          </PrivateRoute>
        } />
        <Route path="/tools/in-app" element={
          <PermissionRoute group="tools/in-app-messages" slug="in-app-designer">
            <InAppDesigner onBack={() => navigate('/tools/in-app-messages')} />
          </PermissionRoute>
        } />
        <Route path="/tools/in-app/:id" element={
          <PermissionRoute group="tools/in-app-messages" slug={["in-app-message-list", "in-app-designer"]}>
            <InAppDesigner onBack={() => navigate('/tools/in-app-messages')} />
          </PermissionRoute>
        } />
        <Route path="/tools/in-app-messages/:id/analytics" element={
          <PermissionRoute group="tools/in-app-messages" slug="in-app-analytics">
            <InAppAnalytics />
          </PermissionRoute>
        } />
        <Route path="/cohorts/create" element={
          <PermissionRoute group="marketing/cohorts" slug={["cohort-list", "cohort-create"]} requireAll>
            <AddCohorts header={"Add New Cohort"} />

          </PermissionRoute>
        } />
        <Route path="/cohorts/detail/:id" element={
          <PermissionRoute group="marketing/cohorts" slug="cohort-view">
            <CohortsDetails header={"Cohort Details"} />

          </PermissionRoute>
        } />
        <Route path="/cohort/edit/:id" element={
          <PermissionRoute group="marketing/cohorts" slug="cohort-edit">
            <EditCohorts header={"Edit Cohort"} />

          </PermissionRoute>
        } />
        <Route path="/campaign/:id" element={
          <PermissionRoute group="marketing/campaign" slug="campaign-edit">
            <EditCampaign header={"Campaign Manager"} />

          </PermissionRoute>
        } />
        <Route path="/campaign/reports/:id" element={
          <PermissionRoute group="marketing/campaign" slug="campaign-report">
            <CampaignReport header={"Campaign Manager"} />

          </PermissionRoute>
        } />
        <Route path="/message-api-doc" element={
          <PrivateRoute>
            <MessageAPIDoc header={"Message API Documentation"} />

          </PrivateRoute>
        } />
        <Route path="/documentation/webhook-doc" element={
          <PrivateRoute>
            <WebhookDocumentation header={"WebHook Documentation"} />

          </PrivateRoute>
        } />
        {/* <Route path="/webhook-doc" element={
          <PrivateRoute>
            <WebhookDocumentation header={"WebHook Documentation"} />

          </PrivateRoute>
        } /> */}
        <Route path="/documentation/configure-apn" element={
          <PrivateRoute>
            < ConfigureAPN header={"Apple Push Notification Configuration"} />

          </PrivateRoute>
        } />
        <Route path="/contacts" element={
          <PrivateRoute>
            < ContactsManagement header={"Contacts"} />

          </PrivateRoute>
        } />
        <Route path="/flow-create" element={
          <PermissionRoute group="flow" slug="flow-create">
            < CampaignFlowBuilder header={"Campaign Flow Builder"} />

          </PermissionRoute>
        } />
        <Route path="/flow" element={
          <PrivateRoute>
            <FlowList header={"Campaign Flow Builder"} />

          </PrivateRoute>
        } />
        <Route path="/flow/:id" element={
          <PermissionRoute group="flow" slug={["flow-edit", "flow-list"]} allowIfState={{ key: 'justCreated', slug: 'flow-create' }}>
            < EditFlow header={"Campaign Flow Builder"} />

          </PermissionRoute>
        } />
        <Route path="/analytics/session-journey" element={
          <PrivateRoute>
            < SessionJourneyExplorer header={"Campaign Flow Builder"} />

          </PrivateRoute>
        } />
        {/* FEAT-SESSIONS-001 — Session Analyzer (rules on ended sessions → xFlow) */}
        <Route path="/marketing/session-analyzer" element={
          <PrivateRoute>
            <SessionAnalyzer header={"Session Analyzer"} />
          </PrivateRoute>
        } />
        {/* FEAT-DEEPLINK-001 — Content → Deep Link Library */}
        <Route path="/content/deep-link-library" element={
          <PermissionRoute group="content/deep-link-library" slug="deep-link-list">
            <DeepLinkLibrary />
          </PermissionRoute>
        } />
        {/* FEAT-REMINDERS-001 — Content → On-Device Reminders */}
        <Route path="/content/reminders" element={
          <PrivateRoute>
            <ReminderList />
          </PrivateRoute>
        } />
        <Route path="/content/reminders/new" element={
          <PermissionRoute group="content/reminders" slug="reminder-editor">
            <ReminderEditor />
          </PermissionRoute>
        } />
        <Route path="/content/reminders/:id" element={
          <PermissionRoute group="content/reminders" slug={["reminder-list", "reminder-editor"]}>
            <ReminderEditor />
          </PermissionRoute>
        } />
        <Route path="/flow-execution/:id" element={
          <PermissionRoute group="flow" slug="flow-execution-view">
            < FlowExecution header={"Campaign Flow Builder"} />

          </PermissionRoute>
        } />
        <Route path="/marketing/Asklytics" element={
          <PrivateRoute>
            < Asklytics />

          </PrivateRoute>
        } />
        <Route path="/flow-execution-detail/:id" element={
          <PermissionRoute group="flow" slug="flow-execution-detail">
            < ExecutionDetail header={"Campaign Flow Builder"} />

          </PermissionRoute>
        } />
        <Route path="/analytics/funnels" element={
          <PrivateRoute>
            < FunnelList header={"Campaign Flow Builder"} />

          </PrivateRoute>
        } />
        <Route path="/analytics/funnels-create" element={
          <PermissionRoute group="analytics/funnels" slug="funnel-create">
            < FunnelBuilder header={"Campaign Flow Builder"} />

          </PermissionRoute>
        } />
        <Route path="/analytics/funnels-edit/:id" element={
          <PermissionRoute group="analytics/funnels" slug={["funnel-edit", "funnel-view"]}>
            <EditFunnel header={"Campaign Flow Builder"} />

          </PermissionRoute>
        } />
        <Route path="/analytics/funnels-view/:id" element={
          <PermissionRoute group="analytics/funnels" slug="funnel-view">
            < FunnelBuilder header={"Campaign Flow Builder"} readOnly={true} />

          </PermissionRoute>
        } />
        <Route path="/contacts-report/:id" element={
          <PermissionRoute group="contacts" slug="contact-list">
            < ContactReport header={"Contacts"} />

          </PermissionRoute>
        } />
        <Route path="/documentation/configure-push-notification" element={
          <PrivateRoute>
            <ConfigurePushNotification header={"Configure Push Notification"} />

          </PrivateRoute>
        } />
        <Route path="/documentation/channel-opt" element={
          <PrivateRoute>
            <ChannelOptDoc header={"Configure Push Notification"} />

          </PrivateRoute>
        } />
        <Route path="/documentation/configure-sdk" element={
          <PrivateRoute>
            <Configuresdk header={"Configure SDK"} />

          </PrivateRoute>
        } />
        <Route path="/documentation-old" element={
          <PrivateRoute>
            <ConfiguresdkLegacy header={"Configure SDK"} />

          </PrivateRoute>
        } />
        <Route path="/message-logs" element={
          <PrivateRoute>
            <MessageLogs header={"Delivery Report"} />

          </PrivateRoute>
        } />
        <Route path="/on-device-reminder-logs" element={
          <PrivateRoute>
            <ReminderLogs header={"On-Device Reminder Logs"} />
          </PrivateRoute>
        } />
        <Route path="/routing-methods" element={
          <PrivateRoute>
            <RoutingMethods header={"Routing Methods"} />

          </PrivateRoute>
        } />
        {/* Legacy, unguarded page — superseded by /template-manager. Kept as a
            redirect (not deleted) since old links/bookmarks may still point here. */}
        <Route path="/template-message" element={<LegacyRedirect toTemplate="/template-manager" />} />
        <Route path="/domain-error" element={
          <DomainError />
        } />

        <Route path="/template-manager" element={
          <PrivateRoute>
            <TemplateManager />

          </PrivateRoute>
        } />
        <Route path="/template-add" element={
          <PrivateRoute>
            {/* <CreateTemplate /> */}
            <TemplateManagerNew />

          </PrivateRoute>
        } />
        <Route path="/template-add-new" element={
          <PrivateRoute>
            {/* <CreateTemplate /> */}
            <TemplateManagerNew />

          </PrivateRoute>
        } />
        <Route path="/template-edit/:id" element={
          <PrivateRoute>
            {/* <EditTemplate />
             */}
            <TemplateManagerNewCreate isEdit={true} />


          </PrivateRoute>
        } />
        <Route path="/template-edit-new/:id" element={
          <PrivateRoute>
            <TemplateManagerNewCreate isEdit={true} />

          </PrivateRoute>
        } />
        <Route path="/support/tickets" element={
          <PrivateRoute>
            <MyTickets />
          </PrivateRoute>
        } />
        <Route path="/support/ticket/:id" element={
          <PrivateRoute>
            <TicketDetail />
          </PrivateRoute>
        } />
        <Route path="/support/create-ticket" element={
          <PrivateRoute>
            <CreateTicket />
          </PrivateRoute>
        } />


        <Route path="/marketing/rfm-models" element={
          <PrivateRoute>
            <RFMModels header={"RFM Models"} />
          </PrivateRoute>
        } />
        <Route path="/marketing/rfm-models/configure/:id" element={
          <PermissionRoute group="marketing/rfm-models" slug="rfm-model-configure">
            <RFMConfiguration header={"Configure RFM Model"} />
          </PermissionRoute>
        } />
        <Route path="/marketing/rfm-models/dashboard/:id" element={
          <PrivateRoute>
            <RFMDashboard header={"RFM Analytics Dashboard"} />
          </PrivateRoute>
        } />

        {/* ── Metric Tree (standalone feature) ── */}
        <Route path="/analytics/metric-tree" element={<PrivateRoute><MetricTreeList /></PrivateRoute>} />
        {/* FEAT-ANALYTICS-001 — GA-style Analytics dashboard (web/app/API/messaging) */}
        <Route path="/analytics" element={<PrivateRoute><Analytics /></PrivateRoute>} />
        <Route path="/analytics/metric-tree/:id" element={<PermissionRoute group="analytics/metric-tree" slug={["metric-tree-view", "metric-tree-edit"]} allowIfState={{ key: 'justCreated', slug: 'metric-tree-create' }}><MetricTreeCanvas /></PermissionRoute>} />

        {/* ── Smart Links (M06 cycle 1) ── */}
        <Route path="/marketing/smart-links/*" element={<PrivateRoute><SmartLinks /></PrivateRoute>} />


        {/* ── Story Builder ── */}
        <Route path="/marketing/story-builder" element={<PrivateRoute><StoryDashboard /></PrivateRoute>} />
        <Route path="/marketing/story-builder/:id/edit" element={<PermissionRoute group="marketing/story-builder" slug="story-builder-create"><EditorPage /></PermissionRoute>} />
        <Route path="/marketing/story-builder/:id/play" element={<PermissionRoute group="marketing/story-builder" slug="story-builder-list"><StoryPlayer /></PermissionRoute>} />
        <Route path="/marketing/story-builder/:id/view" element={<PermissionRoute group="marketing/story-builder" slug="story-builder-list"><StoryViewPage /></PermissionRoute>} />

        {/* ── Legacy redirects: old paths for routes moved under /analytics ──
            The top nav's links come from the backend's nav/permission data
            (Header.js), not this file, so these old URLs stay reachable (via
            the nav) until the backend's nav slug for each is updated to match.
            Delete each line once that's done. */}
        <Route path="/marketing/funnels" element={<LegacyRedirect toTemplate="/analytics/funnels" />} />
        <Route path="/marketing/funnels-create" element={<LegacyRedirect toTemplate="/analytics/funnels-create" />} />
        <Route path="/marketing/funnels-edit/:id" element={<LegacyRedirect toTemplate="/analytics/funnels-edit/:id" />} />
        <Route path="/marketing/funnels-view/:id" element={<LegacyRedirect toTemplate="/analytics/funnels-view/:id" />} />
        <Route path="/marketing/session-journey" element={<LegacyRedirect toTemplate="/analytics/session-journey" />} />
        <Route path="/reports/usage-report" element={<LegacyRedirect toTemplate="/analytics/usage-report" />} />
        <Route path="/insights" element={<LegacyRedirect toTemplate="/analytics/insights" />} />
        <Route path="/insights/:id" element={<LegacyRedirect toTemplate="/analytics/insights/:id" />} />
        <Route path="/metric-tree" element={<LegacyRedirect toTemplate="/analytics/metric-tree" />} />
        <Route path="/metric-tree/:id" element={<LegacyRedirect toTemplate="/analytics/metric-tree/:id" />} />
        <Route path="/marketing/flow-create" element={<LegacyRedirect toTemplate="/flow-create" />} />
        <Route path="/marketing/flow" element={<LegacyRedirect toTemplate="/flow" />} />
        <Route path="/marketing/flow/:id" element={<LegacyRedirect toTemplate="/flow/:id" />} />
        <Route path="/marketing/flow-execution/:id" element={<LegacyRedirect toTemplate="/flow-execution/:id" />} />
        <Route path="/marketing/flow-execution-detail/:id" element={<LegacyRedirect toTemplate="/flow-execution-detail/:id" />} />

        {/* Catch-all — any unmatched URL gets a real 404 instead of a blank page. */}
        <Route path="*" element={<PrivateRoute><NotFound /></PrivateRoute>} />
      </Routes>
      </CsvExportProvider>

    </ChakraProvider>

  );
}

export default App;
